import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const CategoriaPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [category, setCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const CONSUMER_KEY = 'ck_10a7f64bb813e5c80da979e6c7aec6d878caa883';
  const CONSUMER_SECRET = 'cs_ca1236282d5689c22bb93e0122c5650937500cee';

  useEffect(() => {
    const fetchCategoryData = async () => {
      try {
        setLoading(true);
        
        // Fetch datos de la categoría específica
        const CATEGORY_URL = `https://demo.iconestudio.es/wp-json/wc/v3/products/categories/${id}?consumer_key=${CONSUMER_KEY}&consumer_secret=${CONSUMER_SECRET}`;
        const categoryResponse = await fetch(CATEGORY_URL);
        
        if (!categoryResponse.ok) {
          throw new Error(`Error HTTP categoría: ${categoryResponse.status}`);
        }

        const categoryData = await categoryResponse.json();
        setCategory(categoryData);

        // Fetch todos los productos
        const PRODUCTS_URL = `https://demo.iconestudio.es/wp-json/wc/v3/products?per_page=100&consumer_key=${CONSUMER_KEY}&consumer_secret=${CONSUMER_SECRET}`;
        const productsResponse = await fetch(PRODUCTS_URL);
        
        if (!productsResponse.ok) {
          throw new Error(`Error HTTP productos: ${productsResponse.status}`);
        }

        const productsData = await productsResponse.json();
        const publishedProducts = productsData.filter(product => product.status === 'publish');
        
        // Filtrar productos por esta categoría
        const productsInCategory = publishedProducts.filter(product => {
          if (!product.categories || !Array.isArray(product.categories)) return false;
          const productCategoryIds = product.categories.map(cat => cat.id || cat);
          return productCategoryIds.includes(parseInt(id));
        });
        
        setProducts(productsInCategory);
        setLoading(false);

      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    if (id) {
      fetchCategoryData();
    }
  }, [id]);

  const handleProductClick = (productId) => {
    navigate(`/producto/${productId}`);
  };

  const handleBackClick = () => {
    navigate(-1); // Volver a la página anterior
  };

  const getPriceRange = (product) => {
    if (product.type !== 'variable') {
      const isOnSale = product.sale_price && product.sale_price !== "" && product.sale_price !== product.regular_price;
      return isOnSale ? 
        { price: `${product.sale_price} €`, original: `${product.regular_price} €`, isSale: true } : 
        { price: `${product.price} €`, isSale: false };
    }
    
    return { price: "Consultar precio", isSale: false };
  };

  const getCategoryIcon = (categoryName) => {
    const name = categoryName.toLowerCase();
    
    if (name.includes('moto') || name.includes('motor')) return '🏍️';
    if (name.includes('coche') || name.includes('auto')) return '🚗';
    if (name.includes('bici') || name.includes('ciclo')) return '🚲';
    if (name.includes('camión') || name.includes('camion')) return '🚚';
    if (name.includes('herramienta')) return '🛠️';
    if (name.includes('electrón') || name.includes('electron')) return '🔌';
    if (name.includes('ropa') || name.includes('vestimenta')) return '👕';
    if (name.includes('deporte')) return '⚽';
    if (name.includes('hogar')) return '🏠';
    if (name.includes('jardín') || name.includes('jardin')) return '🌿';
    if (name.includes('tecnolog')) return '💻';
    if (name.includes('libro')) return '📚';
    if (name.includes('música') || name.includes('musica')) return '🎵';
    if (name.includes('juguete')) return '🧸';
    if (name.includes('comida')) return '🍎';
    if (name.includes('bebida')) return '🥤';
    if (name.includes('salud')) return '💊';
    if (name.includes('belleza')) return '💄';
    
    return '📦';
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        flexDirection: 'column',
        padding: '40px 20px',
        background: '#f8f9fa'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '20px', animation: 'spin 1s linear infinite' }}>🔄</div>
        <h2 style={{ color: '#333', marginBottom: '10px' }}>Cargando categoría...</h2>
        <p style={{ color: '#666' }}>Buscando productos en esta categoría</p>
        <style>
          {`
            @keyframes spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        background: '#ffe6e6',
        padding: '40px 20px',
        borderRadius: '12px',
        textAlign: 'center',
        margin: '20px',
        maxWidth: '600px',
        marginLeft: 'auto',
        marginRight: 'auto'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '20px' }}>❌</div>
        <h2 style={{ color: '#d32f2f', marginBottom: '10px' }}>Error al cargar la categoría</h2>
        <p style={{ color: '#666', marginBottom: '20px' }}>{error}</p>
        <button
          onClick={handleBackClick}
          style={{
            background: '#1A3357',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            marginRight: '10px'
          }}
        >
          Volver
        </button>
        <button
          onClick={() => window.location.reload()}
          style={{
            background: 'transparent',
            color: '#1A3357',
            border: '2px solid #1A3357',
            padding: '10px 20px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600'
          }}
        >
          Reintentar
        </button>
      </div>
    );
  }

  if (!category) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '60px 20px',
        background: '#f8f9fa'
      }}>
        <div style={{ fontSize: '64px', marginBottom: '20px' }}>🔍</div>
        <h2 style={{ color: '#666', marginBottom: '10px' }}>Categoría no encontrada</h2>
        <p style={{ color: '#999', marginBottom: '20px' }}>La categoría que buscas no existe o ha sido eliminada</p>
        <button
          onClick={handleBackClick}
          style={{
            background: '#1A3357',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600'
          }}
        >
          Volver a la tienda
        </button>
      </div>
    );
  }

  return (
    <div style={{
      fontFamily: "'Montserrat', 'Segoe UI', sans-serif",
      minHeight: '100vh',
      background: '#f8f9fa'
    }}>
      {/* Header de la categoría */}
      <div style={{
        background: 'linear-gradient(135deg, #1A3357, #3496D2)',
        color: 'white',
        padding: '40px 20px',
        marginBottom: '30px'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          position: 'relative'
        }}>
          <button
            onClick={handleBackClick}
            style={{
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              backdropFilter: 'blur(10px)',
              marginBottom: '20px'
            }}
          >
            ← Volver
          </button>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
            flexWrap: 'wrap'
          }}>
            <div style={{
              width: '80px',
              height: '80px',
              background: 'rgba(255,255,255,0.2)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '32px',
              backdropFilter: 'blur(10px)',
              flexShrink: 0
            }}>
              {getCategoryIcon(category.name)}
            </div>

            <div style={{ flex: 1 }}>
              <h1 style={{
                fontSize: '2.5rem',
                fontWeight: '700',
                margin: '0 0 10px 0',
                lineHeight: '1.2'
              }}>
                {category.name}
              </h1>
              
              {category.description && (
                <p style={{
                  fontSize: '1.1rem',
                  opacity: 0.9,
                  lineHeight: '1.5',
                  marginBottom: '15px'
                }}>
                  {category.description.replace(/<[^>]*>/g, '')}
                </p>
              )}

              <div style={{
                background: 'rgba(255,255,255,0.2)',
                padding: '8px 16px',
                borderRadius: '20px',
                display: 'inline-block',
                fontSize: '0.9rem',
                fontWeight: '600',
                backdropFilter: 'blur(10px)'
              }}>
                {products.length} producto{products.length !== 1 ? 's' : ''} en esta categoría
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Grid de productos */}
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px 40px'
      }}>
        {products.length > 0 ? (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: '25px'
          }}>
            {products.map(product => {
              const priceInfo = getPriceRange(product);
              const mainImage = product.images && product.images[0];

              return (
                <div
                  key={product.id}
                  onClick={() => handleProductClick(product.id)}
                  style={{
                    background: 'white',
                    border: '1px solid #e0e0e0',
                    borderRadius: '12px',
                    padding: '20px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-5px)';
                    e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                  }}
                >
                  {/* Imagen del producto */}
                  {mainImage ? (
                    <img
                      src={mainImage.src}
                      alt={mainImage.alt || product.name}
                      style={{
                        width: '100%',
                        height: '200px',
                        objectFit: 'contain',
                        borderRadius: '8px',
                        marginBottom: '15px',
                        background: '#f8f9fa'
                      }}
                    />
                  ) : (
                    <div style={{
                      width: '100%',
                      height: '200px',
                      background: '#f8f9fa',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '48px',
                      color: '#ccc',
                      marginBottom: '15px'
                    }}>
                      🏍️
                    </div>
                  )}

                  {/* Nombre del producto */}
                  <h3 style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    margin: '0 0 10px 0',
                    color: '#333',
                    minHeight: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: '1.3'
                  }}>
                    {product.name}
                  </h3>

                  {/* Precio */}
                  <div style={{ marginBottom: '15px' }}>
                    <span style={{
                      color: priceInfo.isSale ? '#e91e63' : '#2196f3',
                      fontWeight: 'bold',
                      fontSize: '20px',
                      display: 'block'
                    }}>
                      {priceInfo.price}
                    </span>
                    {priceInfo.original && (
                      <span style={{
                        color: '#999',
                        textDecoration: 'line-through',
                        fontSize: '16px',
                        marginRight: '10px'
                      }}>
                        {priceInfo.original}
                      </span>
                    )}
                    {priceInfo.isSale && (
                      <span style={{
                        display: 'inline-block',
                        background: '#ff1744',
                        color: 'white',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        marginTop: '5px'
                      }}>
                        🎉 OFERTA
                      </span>
                    )}
                  </div>

                  {/* Stock status */}
                  <div style={{
                    fontSize: '12px',
                    color: product.stock_status === 'instock' ? '#4caf50' : '#f44336',
                    fontWeight: '600'
                  }}>
                    {product.stock_status === 'instock' ? '✅ En stock' : '❌ Sin stock'}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div style={{
            textAlign: 'center',
            padding: '60px 20px',
            background: 'white',
            borderRadius: '12px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
          }}>
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>📭</div>
            <h3 style={{ color: '#666', marginBottom: '10px' }}>
              No hay productos en esta categoría
            </h3>
            <p style={{ color: '#999', marginBottom: '20px' }}>
              Prueba con otra categoría o vuelve más tarde
            </p>
            <button
              onClick={handleBackClick}
              style={{
                background: '#1A3357',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '600'
              }}
            >
              Volver a la tienda
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoriaPage;